import { render } from "./SearchBarProp.vue?vue&type=template&id=51777256&scoped=true"
import script from "./SearchBarProp.vue?vue&type=script&lang=js"
export * from "./SearchBarProp.vue?vue&type=script&lang=js"

import "./SearchBarProp.vue?vue&type=style&index=0&id=51777256&scoped=true&lang=less"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51777256"]])

export default __exports__